// extracted by mini-css-extract-plugin
export default {"container":"storeStatus_container__BsDl0","status_btn":"storeStatus_status_btn__ScJ7S"};